import {assetUrl} from "../../helpers/urlHelper";
import {shuffle} from "../../helpers/shuffle";
import sha1 from 'crypto-js/sha1';

class Game {
  static getInstance() {
    if (!Game._instance) {
      Game._instance = new Game()
    }

    return Game._instance
  }

  constructor() {
    const wastes = null
    const wastebins = null
    this.wastes = wastes; // Liste des emballages à associer à une règle
    this.wastebins = wastebins; // Liste des Regles

    this.init();
  }

  init() {
    this.operationName = null;
    this.isRandomOrder = false; // Indique si la liste doit être généré de manière aléatoire. (Récupéré depuis la config de l'opération)
    this.score = 0
    this.finalTime = 0; // Durée du jeu (lorsque le joueur à fini)
    this.answers = []; // Liste des réponses aux jeu pas le joueur.

    // Pour gerer un ordre aléatoire qui alterne entre les gestes, nous avons besoin des éléments suivants :
    this.wastesByGeste = []; // Double liste, liste des emballages regroupé par geste
    this.workWaste = null; // Emballage en cours (à scanner ou à choisir la règle)
    this.workGesteIndex = -1; // L'index du geste en cours (pour pouvoir passer au geste suivant lors du passage à l'emballage suivant)
    this.workWasteIndexByGeste = []; // Conserve pour chaque geste, l'index de dernier emballage choisit (pour pouvoir passer à l'emballage suivant)
  }

  updateWasteDetail(config, operationName) {
      let fn = this;
      if(config.randomMaterialOrder === undefined) config.randomMaterialOrder = true;

      // Only update if the operationNameChange
      if (operationName && this.operationName !== operationName) {
        this.operationName = operationName;
        this.isRandomOrder = config.randomMaterialOrder;
        this.wastebins = config.activeDTLRegles;
        this.wastes = config.activeDTLProduits;
        // Ajout de l'info de geste sur li'emballage (pour le tri)
        this.wastes = this.wastes.map((waste) => {
          let wastebin = fn.getWastebinByWastebinId(waste.regleId);
          waste['geste'] = wastebin.geste
          return waste;
        });

        this.preloadWastesImages();
        this.preloadWastebinsImages();
        this.startGame();
        this.getNextWaste();
      }
  }

  getImage(image) {
    return assetUrl(image)
  }

  preloadWastesImages() {
    // console.log('preloadWastesImages', this.wastes);
    Object.keys(this.wastes).map((waste) => {
      const img = new Image();
      img.src =  this.wastes[waste].imageUrl
      return false
    })
  }

  preloadWastebinsImages() {
    // console.log('preloadWastebinsImages', this.wastebins);
    Object.keys(this.wastebins).map((wastebin) => {
      const img = new Image();
      img.src =  this.wastebins[wastebin].imageUrl
      return false
    })
  }

  startGame() {
    // Au démarrage du jeu, on crée la liste des produits et mélange les produits de manière "aléatoire"
    if(this.isRandomOrder){
      this.generateRandomList(); // remplis this.gesteList && this.wastesByGeste
    }else{
      this.generateSimpleList(); // remplis this.gesteList && this.wastesByGeste
    }

    this.initWorkIndexes();
  }

  generateRandomList() {
    let gesteList = {}; // Liste des emballages, indexé par geste (pour les regrouper avant le shuffle)
    // Pour chaque type de geste, on constitue la liste des emballages
    this.wastes.forEach(function(wasteWithGeste){
      const sha1String = sha1(wasteWithGeste.geste);
      if (!Object.keys(gesteList).includes(sha1String.toString())) {
        gesteList[sha1String.toString()] = [];
      }
      gesteList[sha1String.toString()].push(wasteWithGeste);
    });

    // Une fois chaque liste constitué, on shuffle chaque liste
    gesteList = Object.values(gesteList).map((wasteListe) => shuffle(wasteListe));

    // De plus on shuffle l'ordre des gestes
    this.wastesByGeste = shuffle(gesteList);
  }

  generateSimpleList() {
    // Lors d'une liste simple on défini un faux geste qui est le même pour tous.
    this.wastesByGeste.push(this.wastes);
  }

  initWorkIndexes() {
    // Pour chaque type de geste on initialise le premier index
    this.wastesByGeste.map((wasteListe, index) => {
      this.workWasteIndexByGeste[index] = -1;
      return false;
    });

    this.workGesteIndex = -1;
  }

  getWastebinByWastebinId(wastebinId) {
    var result = null;
    this.wastebins.forEach(function(wastebin){
      if (wastebin.id === wastebinId) {
        result = wastebin;
      }
    });
    return result;
  }

  // Fonction pour passer au prochain emballage sans le supprimer de la liste des emballages à scanner (l'emballage en cours reviendra plus tard dans la liste)
  skip() {
    // On remet l'emballage en cours dans la liste là où il était précédemment
    this.wastesByGeste[this.workGesteIndex].splice(this.workWasteIndexByGeste[this.workGesteIndex], 0, this.workWaste);

    this.getNextWaste();
  }

  currentWasteValidated() {
    // Quand l'emballage à été noté dans les réponses, on passe au suivant.
    // On doit diminuer de 1 l'index du geste en cours pour ne pas sauter un emballage
    this.workWasteIndexByGeste[this.workGesteIndex] = this.workWasteIndexByGeste[this.workGesteIndex] - 1;
    // Avant de passer au suivant on vérifie que l'index du geste en cours n'est pas vide.
    // Si c'est le cas, on supprime l'index de la liste d'index par geste et on diminue de 1 l'index des gestes pour ne pas sauter de geste
    if (this.wastesByGeste[this.workGesteIndex].length === 0) {
      this.workWasteIndexByGeste.splice(this.workGesteIndex, 1);
      this.wastesByGeste.splice(this.workGesteIndex, 1);
      this.workGesteIndex--;
    }

    // Si il n'y a plus de geste dispo, on vide l'emballage en cours et on ne passe pas au prochain.
    if (this.wastesByGeste.length === 0) {
      this.workWaste = null;
      return;
    }

    this.getNextWaste();
  }

  getNextWaste() {
    // On met à jour l'index.
    this.updateToNextIndex();

    // On extrait le prochain emballage (ce dernière n'est donc plus dans la liste)
    this.workWaste = this.wastesByGeste[this.workGesteIndex].splice(this.workWasteIndexByGeste[this.workGesteIndex], 1)[0];
  }

  updateToNextIndex() {
    // On passe au prochain type de geste
    // Si l'index en cours est le dernier on repart à 0
    this.workGesteIndex = this.workGesteIndex === this.workWasteIndexByGeste.length-1 ? 0 : this.workGesteIndex+1;

    // Dans le nouvel index de geste on passe au prochain emballage
    // Si l'index en cours est le dernier de la liste on repart à 0
    this.workWasteIndexByGeste[this.workGesteIndex] =
        this.workWasteIndexByGeste[this.workGesteIndex] === this.wastesByGeste[this.workGesteIndex].length-1 ?
            0 : this.workWasteIndexByGeste[this.workGesteIndex]+1;
  }

  answer(wasteBin) {
    if (this.workWaste) {
      const goodAnswer = this.workWaste.regleId === wasteBin.id
      this.answers.push({
        waste: this.workWaste,
        answeredId: wasteBin.id,
        goodAnswer
      })

      if (goodAnswer) {
        this.score++
      }
    }
  }

  /* Getter functions */
  // Liste des wastebins (Regles) à afficher pour le sorting
  getWastebins() {
    return this.wastebins;
  }

  getCurrentWaste() {
    // console.log('getCurrentWaste', this.workWaste, this.workIndex, this.workRealIndex, this.availableIndexes);
    return this.workWaste
  }

  getScore() {
    return this.score
  }

  setFinalTime(time) {
    this.finalTime = time
  }

  getFinalTime() {
    return this.finalTime
  }

  getFormattedFinalTime() {
    return this.getFormattedTime(this.finalTime)
  }

  getFormattedTime(time) {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  getAnswers() {
    return this.answers
  }

}

Game._instance = null

export default Game.getInstance()
